import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Switch } from "./ui/switch";
import { getConsent, setConsent } from "../lib/consent";
import { legalFor } from "../lib/legal";

const disclaimerDone = () => !!localStorage.getItem("drnova_disclaimer");

export const CookieBanner = ({ lang }) => {
  const [open, setOpen] = useState(() => !getConsent() && disclaimerDone());
  const [custom, setCustom] = useState(false);
  const [ads, setAds] = useState(getConsent()?.ads ?? false);
  const u = legalFor(lang).ui;

  useEffect(() => {
    const show = () => { if (!getConsent()) setOpen(true); };
    const prefs = () => { setAds(getConsent()?.ads ?? false); setCustom(true); setOpen(true); };
    window.addEventListener("drnova:disclaimer", show);
    window.addEventListener("drnova:consent-open", prefs);
    return () => { window.removeEventListener("drnova:disclaimer", show); window.removeEventListener("drnova:consent-open", prefs); };
  }, []);

  if (!open) return null;
  const choose = (v) => { setConsent(v); setOpen(false); setCustom(false); };
  return (
    <div className="card fade-up fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-md rounded-2xl p-4 sm:bottom-6" data-testid="cookie-banner" role="dialog" aria-label={u.bannerTitle}>
      <div className="flex items-center gap-2"><Cookie size={16} className="text-teal-700" /><p className="font-display text-sm font-bold text-slate-900">{u.bannerTitle}</p></div>
      <p className="mt-1.5 text-xs leading-relaxed text-slate-600">{u.bannerText} <Link to="/cookie" className="underline" data-testid="cookie-banner-policy-link">{u.cookie}</Link> · <Link to="/privacy" className="underline" data-testid="cookie-banner-privacy-link">{u.privacy}</Link></p>
      {custom && (
        <div className="mt-3 space-y-2 rounded-xl bg-slate-50 p-3" data-testid="cookie-prefs">
          <Row title={u.necessary} desc={u.necessaryDesc}><Switch checked disabled data-testid="cookie-necessary-switch" /></Row>
          <Row title={u.ads} desc={u.adsDesc}><Switch checked={ads} onCheckedChange={setAds} className="sage-switch" data-testid="cookie-ads-switch" /></Row>
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <button data-testid="cookie-reject-btn" onClick={() => choose(false)} className="flex-1 rounded-full border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-100">{u.reject}</button>
        {custom
          ? <button data-testid="cookie-save-btn" onClick={() => choose(ads)} className="flex-1 rounded-full border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-100">{u.save}</button>
          : <button data-testid="cookie-customize-btn" onClick={() => setCustom(true)} className="flex-1 rounded-full border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-100">{u.customize}</button>}
        <button data-testid="cookie-accept-btn" onClick={() => choose(true)} className="btn-primary flex-1 !py-2 !text-xs">{u.accept}</button>
      </div>
    </div>
  );
};

const Row = ({ title, desc, children }) => (
  <div className="flex items-center justify-between gap-3">
    <div><p className="text-xs font-semibold text-slate-800">{title}</p><p className="text-[11px] text-slate-500">{desc}</p></div>
    {children}
  </div>
);
